<!-- 对 el-button 进行封装，增加 debounce 功能 -->

<template>
  <el-tooltip
    :content="tooltipContent"
    :placement="tooltipPlacement"
    :effect="tooltipEffect"
    :disabled="tooltipDisabled"
    trigger="hover"
    v-bind="tooltipProps"
  >
    <template #content>
      <slot name="tooltipContent"></slot>
    </template>
    <!-- reference -->
    <el-button @click="handleClick" v-bind="$attrs" v-on="restListeners" :class="buttonClassObj">
      <template #default>
        <slot name="default"></slot>
      </template>
    </el-button>
  </el-tooltip>
</template>

<script>
import debounce from 'lodash.debounce'

export default {
  name: 'HcButton',
  props: {
    debounceTime: {
      type: Number,
      default: 300,
    },
    tooltipContent: {
      type: String,
      default: '',
    },
    tooltipPlacement: {
      type: String,
      default: 'top',
    },
    tooltipEffect: {
      type: String,
      default: 'dark',
    },
    tooltipProps: {
      type: Object,
      default() {
        return {}
      },
    },
    hideBorder: {
      type: Boolean,
    },
    hidePadding: {
      type: Boolean,
    },
    transparentBgColor: {
      type: Boolean,
    }
  },
  emits: ['click'], // jack event click
  data() {
    return {}
  },
  computed: {
    buttonClassObj() {
      return {
        'hide-btn-border': this.hideBorder,
        'hide-btn-padding': this.hidePadding,
        'transparent-bg-color': this.transparentBgColor,
      }
    },
    tooltipDisabled() {
      return !this.tooltipContent && !this.$slots.tooltipContent
    },
    restListeners() {
      const ret = {}
      return Object.entries(this.$listeners).forEach(([key, value]) => {
        if (key === 'click') {
          // click 事件被组件本身拦截
          return
        }

        ret[key] = value
      })
    },
  },
  methods: {
    handleClick(...args) {
      this.debounceClick(...args)
    },
  },
  created() {
    // created 之后才能读取props里面的值，所以需要在这里写防抖逻辑
    this.debounceClick = debounce(function(...args) {
      this.$emit('click', ...args)
    }, this.debounceTime)
  },
}
</script>

<style scoped>
.hide-btn-border {
  border-width: 0 !important;
}
.hide-btn-padding {
  padding: 0 !important;
}
.transparent-bg-color {
  background-color: transparent !important;
}
</style>
